import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAppMode } from '@store/global/slice';
import { AppModeEnum } from '@project-types/AppModeEnum';
import { selectLanguage } from '@store/global/selectors';
import { useGetResourcesQuery } from '@api/baseApi';
import { addResourceBundle } from '@translations/functions';



export const useAppLogic = () => {
	const language = useSelector(selectLanguage);
	const dispatch = useDispatch();
	const changeAppMode = (mode: AppModeEnum) => dispatch(setAppMode(mode));

	const { data, isError, isLoading, isFetching } = useGetResourcesQuery({ language: language });

	useEffect(() => {
		if (isError) {
			changeAppMode(AppModeEnum.initDataFailed);
			return;
		}
	}, [ isError ]);

	useEffect(() => {
		if (isLoading || isFetching) {
			changeAppMode(AppModeEnum.initDataStart);
			return;
		}
	}, [ isLoading, isFetching ]);

	useEffect(() => {
		if (data) {
			addResourceBundle(language, data);
			changeAppMode(AppModeEnum.initDataSuccess);
			return;
		}
	}, [ data ]);
}